// NO_MODIFY_THIS_FILE_BAKKA
export default {
  gql: {
    GET_ACTIVITIES: `
      query activities {
        activities {
          items {
            id
            name
            okType
            abandon
            type {
              typeId
              name
              typeColor
            }
            startTime
            endTime
            interval
            dayMember
            dayGuest
            okCancel
            cancelTime
            maxPlayers
            joinIncompleteGroup
            allowGuestRegistration
            invoiceType
            hourPrice {
              hourPriceId
              time
              typeId
              pgbCodeProd
            }
            resources {
              resourceId
              typeId
              name
            }
          }
          totalCount
        }
      }
    `,
    GET_ROW_SLOTS: `
      query activityRowSlots(
        $date: String!,
        $activity: Int!,
        $type: Int,
        $time: Int!,
        $players: [PlayerInput!]!
      ) {
        activityRowSlots(
          date: $date,
          activity: $activity,
          type: $type,
          time: $time,
          players: $players
        ) {
          items {
            hour
            activitySlots {
              typeId
              resourceIds
              pricing {
                price
              }
            }
          }
          totalCount
        }
      }
    `,
    GET_ACTIVITY_HISTORY: `
      query getActivityHistory(
        $golfId: String
        $dateMax: String
      ) {
        getActivityHistory(
          golfId: $golfId
          dateMax: $dateMax
        ) {
          id
          date
          time
          golf {
            id
            name
          }
          bookingId
          status
          nbPlayers
          total {
            currency
            price
            discount
            initPrice
          }
          isLocked
          activity {
            id
            typeId
            resourceId
            pgbCodeProd
            name
          }
          nbAccessories
          players {
            tid
            email
            gender
            handicap
            lastname
            firstname
            licenseNo
            bookId
            bookingId
            payments {
              id
              type
              amount
            }
            price
            discount
            initPrice
          }
        }
      }
    `,
    GET_ACTIVITY: `
      query getActivity(
        $id: String!
      ) {
        getActivity(
          id: $id
        ) {
          id
          date
          time
          golf {
            id
            name
          }
          time9in
          owner {
            name
            email
            phone
            covidCertificate
          }
          total {
            currency
            price
            discount
            initPrice
          }
          paymentMethod
          activity {
            id
            typeId
            resourceId
            pgbCodeProd
            name
          }
          status {
            date
            status
            comment
          }
          players {
            tid
            email
            gender
            handicap
            lastname
            firstname
            licenseNo
            bookId
            bookingId
            payments {
              id
              type
              amount
            }
            price
            discount
            initPrice
          }
          payments {
            amount
            card
            type
            brand
            callNo
            country
            creditCardId
            transactionNo
          }
        }
      }
    `,
    ACTIVITY_BOOK: `
      mutation activityBook(
        $nb: Int!
        $date: String!
        $time: String!
        $time9in: String
        $duration: Int!
        $lockCode: String
        $accountId: String!
        $golf: BookGolfInput!
        $owner: BookOwnerInput!
        $total: BookTotalInput!
        $activity: BookActivityInput!
        $comment: String
        $players: [ActivityPlayerInput]!
        $isPrivatized: Int
        $forceAnonymous: Int
      ) {
        activityBook(
          nb: $nb
          date: $date
          time: $time
          time9in: $time9in
          duration: $duration
          lockCode: $lockCode
          accountId: $accountId
          golf: $golf
          owner: $owner
          total: $total
          activity: $activity
          comment: $comment
          players: $players
          isPrivatized: $isPrivatized
          forceAnonymous: $forceAnonymous
        ) {
          id
          date
          time
          golf {
            id
            name
          }
          time9in
          owner {
            name
            email
            phone
            covidCertificate
          }
          total {
            currency
            price
            discount
            initPrice
          }
          paymentMethod
          activity {
            id
            typeId
            resourceId
            pgbCodeProd
            name
          }
          status {
            date
            status
            comment
          }
          players {
            tid
            email
            gender
            handicap
            lastname
            firstname
            licenseNo
            bookingId
            payments {
              id
              type
              amount
            }
            price
            discount
            initPrice
          }
          payments {
            amount
            card
            type
            brand
            callNo
            country
            creditCardId
            transactionNo
          }
        }
      }
    `,
    ACTIVITY_CANCEL: `
      mutation activityCancel(
      $id: String!
      $failed: Boolean
    ) {
        activityCancel(
          id: $id
          failed: $failed
        ) {
            status
          }
      }
    `,
    ACTIVITY_EDIT: `
      mutation activityEdit(
      $id: String
      $date: String!
      $time: String!
      $accountId: String!
      $golf: BookGolfInput!
      $activity: BookActivityInput!
      $owner: ActivityPlayer!
      $players: [ActivityPlayer]!
    ) {
        activityEdit(
          id: $id
          date: $date
          time: $time
          accountId: $accountId
          golf: $golf
          activity: $activity
          owner: $owner
          players: $players
        ) {
            success
            message
          }
      }
    `,
  },
};
